import React from 'react';
import PropTypes from 'prop-types';
import RoadCareCalculatorInputs from '../../FormComponents/RoadCareCalculatorInputs';

const Form = ({
  formProps,
  handleChangeReleaseYear,
  releaseYear,
  transportUseType,
  disabledUseTypeInput,
}) => (
  <RoadCareCalculatorInputs
    formProps={formProps}
    disabledUseTypeInput={disabledUseTypeInput}
    handleChangeReleaseYear={handleChangeReleaseYear}
    releaseYear={releaseYear}
    transportUseType={transportUseType}
  />
);

Form.propTypes = {
  formProps: PropTypes.shape({
    register: PropTypes.func,
    setValue: PropTypes.func,
    getValues: PropTypes.func,
    errors: PropTypes.shape({}),
    clearError: PropTypes.func,
    watch: PropTypes.func,
  }).isRequired,
  disabledUseTypeInput: PropTypes.bool.isRequired,
  releaseYear: PropTypes.shape({}),
  handleChangeReleaseYear: PropTypes.func.isRequired,
  transportUseType: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.shape({
      en: PropTypes.string,
      hy: PropTypes.string,
      ru: PropTypes.string,
    }),
  }),
};

Form.defaultProps = {
  releaseYear: {},
  transportUseType: {},
};

export default Form;
